<template>
    <div>
        <van-nav-bar
                title="收货提令详情"
                left-text=""
                left-arrow
                fixed
                @click-left="back()"
                v-if="show"
        />

        <div class="contentwarp">
            <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                >
                    <div class="van-doc-demo-block">
                        <van-row>
                            <van-col span="10"><h2 class="van-doc-demo-block__title">Sh123456789</h2></van-col>
                            <van-col span="14"><h2 class="van-doc-demo-block__title" style="text-align: right">
                                审核
                            </h2></van-col>
                        </van-row>
                        <div class="van-cell-group van-hairline--bottom">
                            <div class="van-cell">
                                <div class="van-cell__title"><span>收货日期</span></div>
                                <div class="van-cell__value"><span>2020-20-20</span></div>
                            </div>
                            <div class="van-cell">
                                <div class="van-cell__title"><span>货主</span></div>
                                <div class="van-cell__value"><span>XXXXXXXXXX</span></div>
                            </div>
                            <div class="van-cell">
                                <div class="van-cell__title"><span>送货车号</span></div>
                                <div class="van-cell__value"><span>苏B12345</span></div>
                            </div>
                            <div class="van-cell">
                                <div class="van-cell__title"><span>收货仓库</span></div>
                                <div class="van-cell__value"><span>城南仓</span></div>
                            </div>
                            <div class="van-cell">
                                <div class="van-cell__title"><span>备注</span></div>
                                <div class="van-cell__value"><span>CCCC</span></div>
                            </div>
                            <div class="van-cell">
                                <div class="van-cell__title"><span>创建人</span></div>
                                <div class="van-cell__value"><span>王一一 2010-10-10 10：10</span></div>
                            </div>
                            <div class="van-cell">
                                <div class="van-cell__title"><span>审核人</span></div>
                                <div class="van-cell__value"><span>王一一 2010-10-10 10：10</span></div>
                            </div>
                        </div>

                    </div>
                </van-list>
            </van-pull-refresh>
        </div>




        <div class="van-address-list__bottom">
            <van-button block  type="info" native-type="submit" class="button" @click="onSearch()">
                修改
            </van-button>
        </div>




    </div>
</template>

<script>
    import Vue from 'vue'
    import {
        Button,
        Calendar,
        Cell,
        Col,
        Divider,
        Field,
        Form,
        Grid,
        GridItem,
        Icon,
        Image as VanImage,
        ImagePreview,
        Lazyload,
        List,
        NavBar,
        Picker,
        Popup,
        PullRefresh,
        Radio,
        RadioGroup,
        Row,
        Search,
        Sticky,
        SwipeCell,
        Toast
    } from 'vant';
    import service from '../server/index'

    Vue.use(Lazyload, {
        lazyComponent: true,
    });

    export default {
        name: "Fleet",
        components: {
            [NavBar.name]: NavBar,
            [Search.name]: Search,
            [List.name]: List,
            [Col.name]: Col,
            [Row.name]: Row,
            [Cell.name]: Cell,
            [SwipeCell.name]: SwipeCell,
            [Button.name]: Button,
            [Popup.name]: Popup,
            [Icon.name]: Icon,
            [Field.name]: Field,
            [PullRefresh.name]: PullRefresh,
            [Sticky.name]: Sticky,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio,
            [Calendar.name]: Calendar,
            [Divider.name]: Divider,
            [VanImage.name]: VanImage,
            [ImagePreview.Component.name]: ImagePreview.Component,
            [Grid.name]: Grid,
            [GridItem.name]: GridItem,
            [Form.name]: Form,
            [Picker.name]: Picker
        },
        computed: {},
        data() {
            return {
                show: true,//nav bar
                list: [],
                loading: true,
                finished: false,
                searchValue: {},
                showPickerNotifySta: false,
                selProcessNotifyStatus: '',
                selProcessName: '',
                showPickerPro: false,
                selMachineName: '',
                showPickerMac: false,
                selMachineDetailName: '',
                showPickerMacD: false,
                selProcesstaskStatus: '',
                showPickerProSta: false,
                date: '',
                processData: [],
                processCol: [],
                machineData: [],
                machineCol: [],
                machineDetailData: [],
                machineDetailCol: [],
                addShowPop: false,
                dateFormat: 'YYYY-MM-DD',
                //刷新
                isLoading: false,
                page: 1,
                pageSize: 20,
                //日期选择calendarShow
                calendarShow: false,
                taskCount: 0,
                sumWeight: 0,
                notifyCount: 0,
                //详情pop
                detailPop: false,
                detailList: [],
                packageDetailPop:false,
                productDetailPop:false,
                packageList: [],
                packageNo:[]
            }
        },
        mounted() {
            this.onLoad();
            let parm = {};
            parm.ouid = localStorage.getItem("ouid")
            service.selProcessG(parm).then(res => {
                let data = res.data;
                this.processData = res.data;
                for (let i = 0; i < data.length; i++) {
                    this.processCol.push(data[i].processName)
                }
            })
            service.selMachineNameG(parm).then(res => {
                let data = res.data;
                this.machineData = res.data;
                for (let i = 0; i < data.length; i++) {
                    this.machineCol.push(data[i].machineName)
                }
            })
        },

        methods: {
            formatDate(date) {
                return `${date.getMonth() + 1}/${date.getDate()}`;
            },
            onConfirm(date) {
                this.show = false;
                this.date = this.formatDate(date);
            },
            back() {
                this.$router.replace("/Home/Search")
            },
            addPop() {
                this.show = true;
                this.addShowPop = true;
            },

            onSearch() {
                this.list = [];
                this.page = 1;
                this.show = true;
                this.addShowPop = false;
                this.onLoad();
            },
            onLoad() {
                // 异步更新数据
                // setTimeout 仅做示例，真实场景中一般为 ajax 请求
                setTimeout(() => {
                    for (let i = 0; i < 10; i++) {
                        this.list.push(this.list.length + 1);
                    }

                    // 加载状态结束
                    this.loading = false;

                    // 数据全部加载完成
                    if (this.list.length >= 40) {
                        this.finished = true;
                    }
                }, 1000);
            },
            getDetailList() {
                let createTimeStart = "";
                let createTimeEnd = "";
                let dateStr = this.searchValue
                if (dateStr != null && dateStr != "" && this.searchValue.startDate != "" && this.searchValue.endDate != "") {
                    createTimeStart = this.searchValue.startDate;
                    createTimeEnd = this.searchValue.endDate
                }

                let searchObj = this.searchValue
                searchObj.startDate = createTimeStart
                searchObj.endDate = createTimeEnd
                searchObj.page = this.page;
                searchObj.size = this.pageSize;
                searchObj.ouid = localStorage.getItem("ouid")
                searchObj.customerId = localStorage.getItem("customerId")
                service.selJgProcessnotify(JSON.parse(JSON.stringify(searchObj))).then(res => {
                    if (res.code == "200") {
                        if (res.data.length > 0) {
                            for (let i = 0; i < res.data.length; i++) {
                                this.list.push(res.data[i]);
                            }
                            this.page++
                        } else {
                            this.finished = true;
                        }
                        // 加载状态结束
                        this.loading = false;
                        this.isLoading = false;
                    } else {
                        this.loading = false;
                        this.finished = true;
                        this.isLoading = false;
                        Toast(res.message)
                    }
                })
            },




        }
    }
</script>

<style scoped>


    .contentwarp {
        margin-top: 46px;
        height: calc(100vh - 90px) !important;
        background-color: #f7f8fa;
        overflow: auto;
    }
    .ellipsis {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: left;
    }

    .ellipsisRight {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: right;
    }

    /*/deep/ .van-cell__title {*/
    /*    text-align: left;*/
    /*    -webkit-box-flex: unset;*/
    /*    -webkit-flex: unset;*/
    /*    flex: unset;*/
    /*}*/
    .van-panel__content{
        padding: 10px 16px;
        text-align: left;
        font-size: 16px;
    }
    .searchwarp .van-hairline--top-bottom::after {
        border-width:0;
    }
    .van-doc-demo-block__title {
        margin: 0;
        padding: 15px 16px 10px 16px;
        color: rgba(69, 90, 100, 1);
        font-weight: bold;
        font-size: 14px;
        line-height: 16px;
        text-align: left;
    }
    /deep/ .van-cell__title{
        text-align: left;
        -webkit-box-flex: unset;
        -webkit-flex:unset;
        flex:unset;
        width: 90px;
        color: #969799;
    }
    /deep/ .van-cell__value{
        color: #323233;
    }
    .van-list .van-cell-group::after {
        border-bottom-width: 5px;
    }
    /deep/ .van-cell__title.van-field__label.van-field__label--right{
        text-align: right;
    }
</style>
